// Actions for requesting params
// *
// render-container
export const GET_PARAM_CONTAINER = '@@redux-ABA/GET_PARAM_CONTAINER';
export const SET_PARAM_CONTAINER = '@@redux-ABA/SET_PARAM_CONTAINER';
// language
export const GET_PARAM_LANGUAGE = '@@redux-ABA/GET_PARAM_LANGUAGE';
export const SET_PARAM_LANGUAGE = '@@redux-ABA/SET_PARAM_LANGUAGE';
export const CHANGE_PARAM_LANGUAGE = '@@redux-ABA/CHANGE_PARAM_LANGUAGE';
// base-url
export const GET_PARAM_BASE_URL = '@@redux-ABA/GET_PARAM_BASE_URL';
export const SET_PARAM_BASE_URL = '@@redux-ABA/SET_PARAM_BASE_URL';
// brand
export const GET_PARAM_BRAND = '@@redux-ABA/GET_PARAM_BRAND';
export const SET_PARAM_BRAND = '@@redux-ABA/SET_PARAM_BRAND';
// channel
export const GET_PARAM_CHANNEL = '@@redux-ABA/GET_PARAM_CHANNEL';
export const SET_PARAM_CHANNEL = '@@redux-ABA/SET_PARAM_CHANNEL';
// proxy-prefix
export const GET_PARAM_PROXY_PREFIX = '@@redux-ABA/GET_PARAM_PROXY_PREFIX';
export const SET_PARAM_PROXY_PREFIX = '@@redux-ABA/SET_PARAM_PROXY_PREFIX';
// user-token
export const GET_PARAM_USER_TOKEN = '@@redux-ABA/GET_PARAM_USER_TOKEN';
export const SET_PARAM_USER_TOKEN = '@@redux-ABA/SET_PARAM_USER_TOKEN';
// user-data
export const GET_PARAM_USER_DATA = '@@redux-ABA/GET_PARAM_USER_DATA';
export const SET_PARAM_USER_DATA = '@@redux-ABA/SET_PARAM_USER_DATA';
// client-id
export const GET_PARAM_CLIENT_ID = '@@redux-ABA/GET_PARAM_CLIENT_ID';
export const SET_PARAM_CLIENT_ID = '@@redux-ABA/SET_PARAM_CLIENT_ID';
// platform
export const GET_PARAM_PLATFORM = '@@redux-ABA/GET_PARAM_PLATFORM';
export const SET_PARAM_PLATFORM = '@@redux-ABA/SET_PARAM_PLATFORM';
// deposit-url
export const GET_PARAM_DEPOSIT_URL = '@@redux-ABA/GET_PARAM_DEPOSIT_URL';
export const SET_PARAM_DEPOSIT_URL = '@@redux-ABA/SET_PARAM_DEPOSIT_URL';
// withdrawal-url
export const GET_PARAM_WITHDRAWAL_URL = '@@redux-ABA/GET_PARAM_WITHDRAWAL_URL';
export const SET_PARAM_WITHDRAWAL_URL = '@@redux-ABA/SET_PARAM_WITHDRAWAL_URL';
// layout-dimensions
export const GET_PARAM_LAYOUT_DIMENSIONS = '@@redux-ABA/GET_PARAM_LAYOUT_DIMENSIONS';
export const SET_PARAM_LAYOUT_DIMENSIONS = '@@redux-ABA/SET_PARAM_LAYOUT_DIMENSIONS';
export const CHANGE_LAYOUT_DIMENSIONS = '@@redux-ABA/CHANGE_LAYOUT_DIMENSIONS';
// withdrawal-url
export const GET_PARAM_ASSETS_MANIFEST = '@@redux-ABA/GET_PARAM_ASSETS_MANIFEST';
export const SET_PARAM_ASSETS_MANIFEST = '@@redux-ABA/SET_PARAM_ASSETS_MANIFEST';
// ams segments
export const GET_PARAM_AMS_SEGMENTS = '@@redux-ABA/GET_PARAM_AMS_SEGMENTS';
export const SET_PARAM_AMS_SEGMENTS = '@@redux-ABA/SET_PARAM_AMS_SEGMENTS';
// theme
export const GET_PARAM_THEME = '@@redux-ABA/GET_PARAM_THEME';
export const SET_PARAM_THEME = '@@redux-ABA/SET_PARAM_THEME';
// cross-domain-click-stream-id
export const GET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID = '@@redux-ABA/GET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID';
export const SET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID = '@@redux-ABA/SET_PARAM_CROSS_DOMAIN_CLICK_STREAM_ID';
// brand-hash
export const GET_PARAM_BRAND_HASH = '@@redux-ABA/GET_PARAM_BRAND_HASH';
export const SET_PARAM_BRAND_HASH = '@@redux-ABA/SET_PARAM_BRAND_HASH';
// application-id
export const GET_PARAM_APPLICATION_ID = '@@redux-ABA/GET_PARAM_APPLICATION_ID';
export const SET_PARAM_APPLICATION_ID = '@@redux-ABA/SET_PARAM_APPLICATION_ID';
// operator
export const GET_PARAM_OPERATOR_ID = '@@redux-ABA/GET_PARAM_OPERATOR_ID';
export const SET_PARAM_OPERATOR_ID = '@@redux-ABA/SET_PARAM_OPERATOR_ID';
// api-key
export const GET_PARAM_API_KEY = '@@redux-ABA/GET_PARAM_API_KEY';
export const SET_PARAM_API_KEY = '@@redux-ABA/SET_PARAM_API_KEY';
// *
// Request modals
export const REQUEST_LOGIN_MODAL = '@@redux-ABA/REQUEST_LOGIN_MODAL';
export const REQUEST_DEPOSIT_MODAL = '@@redux-ABA/REQUEST_DEPOSIT_MODAL';
export const REQUEST_APPLICATION_INSTALL_MODAL = '@@redux-ABA/REQUEST_APPLICATION_INSTALL_MODAL';

// Request updates
export const REQUEST_UPDATE_BALANCE = '@@redux-ABA/REQUEST_UPDATE_BALANCE';

// Redirects via deep link
export const REDIRECT_VIA_DEEP_LINK = '@@redux-ABA/REDIRECT_VIA_DEEP_LINK';
export const REDIRECT_VIA_PLAIN_DEEP_LINK = '@@redux-ABA/REDIRECT_VIA_PLAIN_DEEP_LINK';
export const CHANGE_CASHIER_RESULT_URL = '@@redux-ABA/CHANGE_CASHIER_RESULT_URL';

// other
export const CHANGE_INTERFACE_HEADER = '@@redux-ABA/CHANGE_INTERFACE_HEADER';
export const SERVICE_RENDER_ERROR = '@@redux-ABA/SERVICE_RENDER_ERROR';
export const CHANGE_LANGUAGE_ERROR = '@@redux-ABA/CHANGE_LANGUAGE_ERROR';
export const CHANGE_PAGE = '@@redux-ABA/CHANGE_PAGE';
export const CHANGE_PAGE_CALLBACK = '@@redux-ABA/CHANGE_PAGE_CALLBACK';
export const CHANGE_NAVIGATION = '@@redux-ABA/CHANGE_NAVIGATION';

export const CHANGE_AMS_SEGMENTS = '@@redux-ABA/CHANGE_AMS_SEGMENTS';
export const CHANGE_USER_BALANCE = '@@redux-ABA/CHANGE_USER_BALANCE';

// TODO: move to deep links
export const REDIRECT_USER_BONUSES = '@@redux-ABA/REDIRECT_USER_BONUSES';
export const USER_LOGIN = '@@redux-ABA/USER_LOGIN';
export const USER_LOGOUT = '@@redux-ABA/USER_LOGOUT';

export const UPDATE_NAVBAR = '@@redux-ABA/UPDATE_NAVBAR';
export const UPDATE_NAVBAR_CALLBACK = '@@redux-ABA/UPDATE_NAVBAR_CALLBACK';
